import { XTodoCard } from '@adornis/todo/client/x-todo-card.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-todo-card
 */
@customElement('cr-todo-card')
export class ChromiumTodoCard extends XTodoCard {}
